<template>
  <div>
    <div class="content-header">
      <h1>Dodacie listy - náhľad pred tlačou</h1>
    </div>
    <div class="content">

      <div class="row hidden-print">
        <div class="col-md-12">
          <div class="block">
            <button class="btn btn-primary hidden-print" @click.prevent="print()">Tlač</button>
            <button class="btn btn-default hidden-print" @click.prevent="back()">Zrušiť</button>
          </div>
        </div>
      </div>

      <loading id="deliveryNotes"></loading>
      <no-records :data="deliveryNotes" loadingId="deliveryNotes"></no-records>

      <template v-for="deliveryNote in deliveryNotes">
        <section class="print-end-page">
          <div class="box">
            <div class="box-header">
              <h3>Dodací list zo dňa {{ deliveryNote.date | date }}</h3>
              <div class="row">
                <div class="col-xs-6 col-md-3">
                  <u>Dodávateľ:</u>
                  <div><strong>{{ deliveryNote.company.name }}</strong></div>
                  <div>{{ deliveryNote.company.address.streetName }} {{ deliveryNote.company.address.streetNumber }}</div>
                  <div>{{ deliveryNote.company.address.zipCode }} {{ deliveryNote.company.address.city }}</div>
                  <div>IČO: {{ deliveryNote.company.companyId }}</div>
                  <p>IČ DPH: {{ deliveryNote.company.vatId }}</p>
                </div>
                <div class="col-xs-6 col-md-3">
                  <u>Odberateľ:</u>
                  <div><strong>{{ deliveryNote.customer.companyName }}</strong></div>
                  <div>{{ deliveryNote.customer.address.streetName }} {{ deliveryNote.customer.address.streetNumber }}</div>
                  <div>{{ deliveryNote.customer.address.zipCode }} {{ deliveryNote.customer.address.city }}</div>
                  <div>IČO: {{ deliveryNote.customer.companyId }}</div>
                  <p>IČ DPH: {{ deliveryNote.customer.vatId }}</p>
                </div>
              </div>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-md-12">
                  <table class="table table-hover">
                    <thead>
                      <th>Názov</th>
                      <th>Množstvo</th>
                      <th>Spotrebujte do</th>
                      <th>Cena bez DPH</th>
                      <th>DPH</th>
                      <th>Spolu bez DPH</th>
                    </thead>
                    <tbody>
                      <tr v-for="item in deliveryNote.items">
                        <td>{{ item.productName }}</td>
                        <td>{{ item.amount }}</td>
                        <td>{{ item.shelfLife | date }}</td>
                        <td>{{ item.price  | currency }}</td>
                        <td>{{ vatRate }} %</td>
                        <td>{{ item.amount * item.price | currency }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              </div>
            </div>
            <div class="box-footer visible-print  ">
              <div class="row">
                <div class="col-xs-6 col-md-4">
                  <div><span class="sign-title">Vystavil:</span><span> {{ user.fullName }}</span></div>
                </div>
                <div class="col-xs-6 col-md-4">
                  <div><span class="sign-title">Prijal:</span><span>.........................................</span></div>
                  <div class="sign-description">dátum, podpis</div>
                </div>
              </div>
            </div>
        </section>
      </template>
    </div>
  </div>

</template>

<script>
  import {alert} from 'vue-strap';
  import { mapState } from 'vuex';
  import loading from 'components/loading';
  import noRecords from 'components/noRecords';

  export default {
    components: { alert, loading, noRecords },
    computed: {
      ...mapState({
        user: (state) => state.auth.user,
        vatRate: (state) => state.app.configuration.vatRate,
        deliveryNotes: (state) => state.deliveryNote.items
      }),
    },
    methods: {
      back() {
        this.$router.go(-1);
      },
      print() {
        window.print();
      },
      isLastDeliveryNote(deliveryNote) {
        return this.deliveryNotes.indexOf(deliveryNote) === this.deliveryNotes.length - 1;
      },
      fetch() {
        this.$store.dispatch('deliveryNote/findByFilter');
      }
    },
    mounted () {
      this.fetch();
    }
  };
</script>



// WEBPACK FOOTER //
// client/views/deliveryNotesPrint.vue